import { FC, useContext } from 'react'
import { Position } from '../../types'
import { useVisiblePositionPercent } from '../hooks/useVisiblePositionPercent'
import { PositionMilliseconds } from '../components/PositionMilliseconds'
import classNames from 'classnames'
import { CutterContext } from '../contexts/CutterContext'
import './TimelineTick.scss'

interface Props {
  position: Position
}

export const TimelineTick: FC<Props> = ({ position }) => {
  const { length } = useContext(CutterContext).audio
  const percent = useVisiblePositionPercent(position)

  return (
    <div
      className={classNames('TimelineTick', {
        '-first': position === 0,
        '-last': position === length,
      })}
      style={{ left: `${percent}%` }}
    >
      <div className="milliseconds">
        <PositionMilliseconds position={position} />
      </div>

      <div className="stroke"></div>
    </div>
  )
}
